import React, { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Home from "./components/Home";
import UniversalMenuAlumno from "../../components/UniversalMenuAlumno";
import { WebSocketProvider } from "../../context/WebSocketContext";
import { GlobalProvider } from "../../context/GlobalContext";
import MisCursos from "./components/MisCursos/MisCursos";
import MiPerfil from "./components/MiPerfil/MiPerfil";
import CursoComprado from "./components/CursoComprado/CursoComprado";
import AlertaFlotante from "../../components/AlertaFlotante/AlertaFlotante";
import CursosNoComprados from "./components/CursosNoComprados/CursosNoComprados";
import CursoNoComprado from "./components/CursoNoComprado";
import useTokenValidation from "../../hooks/useTokenValidation";
import { getDetallePerfil } from "./service/alumnoService";

export default function Alumno() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [vFrame, setvFrame] = useState(null);
  const vAlertaRef = useRef(null);
  const [loadingPerfil, setLoadingPerfil] = useState(true);
  const [errorPerfil, setErrorPerfil] = useState(null);
  const [perfil, setPerfil] = useState(null);
  const { tokenEntity, resetearToken, errores, notificacionRef } =
    useTokenValidation();

  // Creamos la ref para el contenedor padre con clase "home-contenido"
  const homeContainerRef = useRef(null);

  useEffect(() => {
    if (!searchParams.get("f")) {
      navigate("?f=i");
    }
    console.log(searchParams.get("f"));
    setvFrame(mRednerFrame(searchParams.get("f")));
  }, [searchParams]);

  useEffect(() => {
    if (!tokenEntity.isValidando) {
      const mFetchPerfil = () => {
        getDetallePerfil(tokenEntity.token, 20)
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            switch (response.status) {
              case 400:
                console.log("Datos inválidos en la petición");
                throw new Error("ERR_VALIDATION");
              case 401:
                console.log("Acceso denegado");
                throw new Error("ERR_UNAUTHORIZED");
              case 500:
                console.log("Error al obtener el perfil");
                throw new Error("ERR_SERVER");
              default:
                console.log("Error inesperado");
                throw new Error("ERR_UNKNOWN");
            }
          })
          .then((result) => {
            if (result !== undefined) {
              if (result.detail.acción === "DETALLE_PERFIL_OBTENIDO") {
                setPerfil(result.detail);
              }
            }
          })
          .catch((error) => {
            const { message } = error;
            if (message !== "ERR_ME") {
              console.log("Error de red");
              setErrorPerfil("Error en la conexión con el servidor");
            }
          })
          .finally(() => {
            setLoadingPerfil(false);
          });
      };
      mFetchPerfil();
    }
  }, [tokenEntity.isValidando]);

  const mRednerFrame = (vF) => {
    console.log("Frame", vF);
    switch (vF) {
      case "cc":
        return <CursoComprado scrollRef={homeContainerRef} />;
      case "mc":
        return <MisCursos scrollRef={homeContainerRef}/>;
      case "p":
        // Pasa homeContainerRef a MiPerfil
        return <MiPerfil homeContainerRef={homeContainerRef} />;
      case "cnc":
        return <CursoNoComprado scrollRef={homeContainerRef} />;
      case "tcnc":
        return <CursosNoComprados scrollRef={homeContainerRef}/>;
      default:
        return <Home />;
    }
  };

  return (
    <WebSocketProvider>
      <GlobalProvider
        value={{ vAlertaRef, perfil, loadingPerfil, errorPerfil }}
      >
        <div className="home-body">
          <UniversalMenuAlumno />
          <AlertaFlotante ref={vAlertaRef} />
          {/* Se asigna la ref al contenedor "home-contenido" */}
          <div className="home-contenido" ref={homeContainerRef}>
            {vFrame}
          </div>
        </div>
      </GlobalProvider>
    </WebSocketProvider>
  );
}
